import {
    BubbleLinearIcon,
    Candle2LinearIcon,
    CoinLinearIcon,
    ConvertLinearIcon,
    DiscountCircleLinearIcon,
    DollarCircleLinearIcon,
    EmptyWalletLinearIcon,
    Grid2LinearIcon,
    GroupLinearIcon,
    HomeLinearIcon,
    LevelLinearIcon,
    LocationLinearIcon,
    Money3LinearIcon,
    MoneysLinearIcon,
    MonitorMobbileLinearIcon,
    NotificationStatusLinearIcon,
    PersonalcardLinearIcon,
    Profile2userLinearIcon,
    ProfileCircleLinearIcon,
    ReceiptLinearIcon,
    ReceiveSquare2LinearIcon,
    ScanBarcodeLinearIcon,
    SendSqaure2LinearIcon,
    ShopLinearIcon,
    UserOctagonLinearIcon,
    UserTagLinearIcon,
    ArrangeSquare2LinearIcon
} from '../icons-lib';

export const commonMenu = [
    {
        title: 'GENERAL',
        roles: ['ecoo', 'partner', 'merchant', 'user', 'sme_admin'],
        items: [
            // Dashboard for ecoo users
            {
                titleKey: 'menu.dashboard',
                path: '/app/dashboard',
                icon: <HomeLinearIcon />,
                roles: ['ecoo']
            },
            {
                titleKey: 'menu.overview',
                path: '/app/dashboard',
                icon: <HomeLinearIcon />,
                roles: ['sme_admin', 'partner', 'merchant', 'user']
            },
            {
                titleKey: 'pages.users.title', //rename to overview
                icon: <ProfileCircleLinearIcon />,
                path: '/app/users',
                controller: 'users',
                roles: ['ecoo', 'partner', 'merchant', 'user']
            },
            // {
            //     titleKey: 'pages.rolePermissions.title',
            //     icon: <Candle2LinearIcon />,
            //     path: '/app/role-permissions',
            //     controller: 'roles-permissions'
            // },
            {
                titleKey: 'pages.wallets.title',
                path: '/app/wallets',
                icon: <EmptyWalletLinearIcon />,
                controller: 'wallets'
            },
            // SME Employees – visible for SME Admins via permissions
            {
                titleKey: 'pages.smeEmployees.title',
                path: '/app/sme-company-employees',
                icon: <PersonalcardLinearIcon />,
                controller: 'users',
                roles: ['sme_admin']
            },
            {
                titleKey: 'pages.transactions.title',
                icon: <ReceiptLinearIcon />,
                controller: 'transactions',
                sublistData: [
                    {
                        titleKey: 'pages.internal.title',
                        path: '/app/transactions',
                        icon: <LevelLinearIcon />,
                        controller: 'transactions'
                    },
                    {
                        titleKey: 'pages.externalIncomingTransactions.title',
                        path: '/app/incoming-transactions',
                        icon: <ReceiveSquare2LinearIcon />,
                        controller: 'external-transactions'
                    },
                    {
                        titleKey: 'pages.externalOutgoingTransactions.title',
                        path: '/app/outgoing-transactions',
                        icon: <SendSqaure2LinearIcon />,
                        controller: 'external-transactions'
                    }
                ]
            },
            {
                titleKey: 'pages.partnersShop.title',
                icon: <ShopLinearIcon />,
                controller: 'merchants',
                sublistData: [
                    {
                        titleKey: 'pages.overview.title',
                        path: '/app/merchants',
                        icon: <Grid2LinearIcon />,
                        controller: 'merchants'
                    },
                    {
                        titleKey: 'pages.merchantLocations.title',
                        path: '/app/merchants-locations',
                        icon: <LocationLinearIcon />,
                        controller: 'merchant-locations'
                    },
                    {
                        titleKey: 'pages.merchantEmployees.title',
                        path: '/app/merchant-employees',
                        icon: <PersonalcardLinearIcon />,
                        controller: 'merchant-employees'
                    },
                    {
                        titleKey: 'pages.merchantCategory.title',
                        path: '/app/merchant-categories',
                        icon: <BubbleLinearIcon />,
                        controller: 'merchant-category'
                    }
                    // {
                    //     titleKey: 'pages.merchantInvites.title',
                    //     path: '/app/merchant-invites',
                    //     icon: <UserOctagonLinearIcon />,
                    //     controller: 'merchant-invites'
                    // }
                ]
            },
            // {
            //     titleKey: 'pages.partners.title',
            //     icon: <Profile2userLinearIcon />,
            //     controller: 'partners',
            //     sublistData: [
            //         {
            //             titleKey: 'pages.overview.title',
            //             path: '/app/partners',
            //             icon: <Grid2LinearIcon />,
            //             controller: 'partners'
            //         },
            //         {
            //             titleKey: 'pages.accounts.title',
            //             path: '/app/partner-accounts',
            //             icon: <UserOctagonLinearIcon />,
            //             controller: 'partner-accounts'
            //         },
            //         {
            //             titleKey: 'pages.coins.title',
            //             path: '/app/partner-has-coins',
            //             icon: <CoinLinearIcon />,
            //             controller: 'partner-has-coins'
            //         },
            //         {
            //             titleKey: 'pages.paymentGateways.title',
            //             path: '/app/payment-gateways',
            //             icon: <ConvertLinearIcon />,
            //             controller: 'payment-gateways'
            //         }
            //     ]
            // },
            {
                titleKey: 'pages.payoutAccounts.title',
                icon: <ArrangeSquare2LinearIcon />,
                path: '/app/payout-accounts',
                controller: 'payout-accounts',
                roles: ['ecoo', 'partner', 'merchant', 'user']
            }
        ]
    },
    // {
    //     title: 'MARKETING',
    //     roles: ['ecoo', 'partner', 'merchant', 'user'],
    //     items: [
    //         {
    //             titleKey: 'pages.campaigns.title',
    //             icon: <MonitorMobbileLinearIcon />,
    //             controller: 'marketing-campaigns',
    //             sublistData: [
    //                 {
    //                     titleKey: 'pages.marketingCampaigns.title',
    //                     icon: <NotificationStatusLinearIcon />,
    //                     path: '/app/marketing-campaigns'
    //                 },
    //                 {
    //                     titleKey: 'pages.marketingAudiences.title',
    //                     icon: <UserTagLinearIcon />,
    //                     path: '/app/marketing-audiences'
    //                 }
    //             ]
    //         }
    //     ]
    // },
    {
        title: 'MANAGEMENT',
        roles: ['ecoo', 'user'],
        items: [
            {
                titleKey: 'pages.coins.title',
                icon: <DollarCircleLinearIcon />,
                controller: 'coins',
                sublistData: [
                    {
                        titleKey: 'pages.overview.title',
                        path: '/app/coins',
                        icon: <Grid2LinearIcon />
                    }
                ]
            },
            // {
            //     titleKey: 'pages.currencies.title',
            //     icon: <Money3LinearIcon />,
            //     path: '/app/currencies',
            //     controller: 'currencies'
            // },
            {
                titleKey: 'pages.coinPairs.title',
                icon: <GroupLinearIcon />,
                controller: 'coin-currency-pairs',
                sublistData: [
                    {
                        titleKey: 'pages.coinCurrencyPairs.title',
                        path: '/app/coin-currency-pairs',
                        icon: <CoinLinearIcon />,
                        controller: 'coin-currency-pairs'
                    },
                    {
                        titleKey: 'pages.currencyExchangePairs.title',
                        path: '/app/currency-exchange-pairs',
                        icon: <MoneysLinearIcon />,
                        controller: 'currency-exchange-pairs'
                    },
                    {
                        titleKey: 'pages.currencyExchangeRates.title',
                        path: '/app/currency-exchange-rates',
                        icon: <DiscountCircleLinearIcon />,
                        controller: 'currency-exchange-rates'
                    }
                ]
            },
            // {
            //     titleKey: 'pages.coupons.title',
            //     icon: <ScanBarcodeLinearIcon />,
            //     // controller: 'wallet-coupons',
            //     sublistData: [
            //         {
            //             titleKey: 'pages.inviteCodes.title',
            //             path: '/app/invite-codes',
            //             icon: <ScanBarcodeLinearIcon />,
            //             controller: 'invite-codes'
            //         },
            //         {
            //             titleKey: 'pages.couponTransactions.title',
            //             path: '/app/transaction-coupons',
            //             icon: <DiscountCircleLinearIcon />,
            //             controller: 'coupon-transactions'
            //         }
            //     ]
            // },
            // SME dropdown for Super Admin
            {
                titleKey: 'pages.sme.title',
                icon: <UserOctagonLinearIcon />,
                controller: 'sme-companies',
                sublistData: [
                    {
                        titleKey: 'pages.smeCompanies.title',
                        path: '/app/sme-companies',
                        icon: <Grid2LinearIcon />,
                        controller: 'sme-companies'
                    },
                    {
                        titleKey: 'pages.smeAdmins.title',
                        path: '/app/sme-admins',
                        icon: <PersonalcardLinearIcon />,
                        controller: 'users'
                    },
                    {
                        titleKey: 'pages.smeEmployees.title',
                        path: '/app/sme-company-employees',
                        icon: <Profile2userLinearIcon />,
                        controller: 'users'
                    }
                ]
            }
            // {
            //     titleKey: 'pages.currencyExchangeRates.title',
            //     path: '/app/currency-exchange-rates',
            //     icon: <DiscountCircleLinearIcon />,
            //     controller: 'currency-exchange-rates'
            // }
        ]
    },
    // Management section dedicated for SME Admin with only SME Admins page
    {
        title: 'MANAGEMENT',
        roles: ['sme_admin'],
        items: [
            {
                titleKey: 'pages.smeAdmins.title',
                path: '/app/sme-admins',
                icon: <ProfileCircleLinearIcon />,
                controller: 'users'
            }
        ]
    }
];
